import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-sloan-cms-faq',
    templateUrl: './sloan-cms-faq.component.html',
    styleUrls: ['./sloan-cms-faq.component.scss']
})
export class SloanCmsFaqComponent implements OnInit, OnChanges {
  @Input() questions:any;
  isChangeDone: boolean = false;
  faqDataSource: any[] = [];
  prevIndex: number = null;
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.isChangeDone) {
      if (this.questions && this.questions?.children[0]?.children.length > 0) {
        let faqArray: any = this.questions?.children[0]?.children;
        faqArray.forEach(element => {
          element = { question: element.question, answer: element.answer, expanded: false };
          this.faqDataSource.push(element);
        });
        this.isChangeDone = true;
      }
    }
  }

  toggleAnswer(index: number): void {
    if(this.prevIndex && index!=this.prevIndex-1){
      this.faqDataSource[this.prevIndex-1].expanded = false;
    }
    this.faqDataSource[index].expanded = !this.faqDataSource[index].expanded;
    this.prevIndex = index+1;
  }

  addCollapes(event, i){
  document.querySelectorAll('.accordion-button').forEach((ele, index) => {if(index != i){ele.classList.add('collapsed')}})
  document.querySelectorAll('.collapse').forEach((ele,index) => {if(index != i){ele.classList.remove('show')}})
  event.currentTarget.classList.remove('collapsed')
  }
}  